import { render, staticRenderFns } from "./LocationHistoryTable.vue?vue&type=template&id=1e47133a&"
import script from "./LocationHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./LocationHistoryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports